import { Box, Stack, Typography } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button';
import { Footer, FOOTER_HEIGHT } from '@/components/navigation/Footer';
import { COLORS } from '@/styles/tokens/colors';

export interface FullScreenFormLayoutProps {
  heading: React.ReactNode;
  Content: React.ReactElement;
  Footer: React.ReactElement;
}

interface ModalFooterProps {
  disabled?: boolean;
  onRequestClose: () => void;
  submitCopy: string;
}

export function ModalFooter({
  disabled,
  onRequestClose,
  submitCopy,
}: ModalFooterProps) {
  return (
    <Footer
      leftAction={
        <Button
          disabled={disabled}
          onClick={onRequestClose}
          variant="secondary"
          size="sm"
        >
          Exit without saving
        </Button>
      }
      rightAction={
        <Button disabled={disabled} type="submit" variant="primary" size="sm">
          {submitCopy}
        </Button>
      }
    />
  );
}

export const MODAL_HEADER_HEIGHT = 56;

export function ModalHeader({
  heading,
  rightContent,
}: {
  heading: React.ReactNode;
  rightContent: React.ReactNode;
}) {
  return (
    <Stack
      bgcolor="common.white"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      px={1.5}
      height={MODAL_HEADER_HEIGHT}
      minHeight={MODAL_HEADER_HEIGHT}
      borderBottom={1}
      borderColor={COLORS.GRAY[200]}
    >
      <Typography variant="title-l">{heading}</Typography>
      <Box>{rightContent}</Box>
    </Stack>
  );
}

export function FullScreenFormLayout({
  heading,
  Content,
  Footer,
}: FullScreenFormLayoutProps) {
  return (
    <Box>
      <Stack
        paddingTop={2}
        paddingX={18}
        height={`calc(100vh - ${FOOTER_HEIGHT}px)`}
        overflow="auto"
      >
        <Typography variant="title-xl">{heading}</Typography>
        <Box my={2}>{Content}</Box>
      </Stack>
      <Box>{Footer}</Box>
    </Box>
  );
}
